import { getAdvertiserExts, getAwemes, getSeries, getProductDetails, getProducts, getTitleGroups, getKuaishouCampaigns, getEpisodes, getPayModeType, getPayTemplates } from '@/api/open'
import { getPushRecordCountByName } from '@/api/open'
import { storeOrUpdateAdTask } from '@/api/ad-task'
import moment from 'moment'
import MaterialSelect from '@/components/material-select/MaterialSelect.vue'
import VideoSelect from '@/components/video-select/VideoSelect.vue'
import CodeInput from '@/components/code-input/CodeInput.vue'
import AdvSelect from '@/components/adv-select/AdvSelect.vue'
import { pullAnchor, syncLandingPage } from '@/api/advertiser'

export default {
    components: {
        MaterialSelect,
        VideoSelect,
        CodeInput,
        AdvSelect
    },
    props: {
        params: {
            type: Object,
            required: true
        },
        media: {
            type: String,
            required: true
        },
        showCreateForm: {
            type: Boolean,
            required: true
        },
    },
    data() {
        return {
            labelCol: { span: 5 },
            wrapperCol: { span: 17 },
            medias: [],
            advs: {},
            model: {
                ids: [],
                name: '',
                type: 30,
                ad_type: 0,
                bid_type: 0,
                budget_type: 0,
                day_budget: 0,
                auto_manage: 1,
                num: 1,
                ys:1,
                bw:1,
                scene_id: [6,7],
                campaign_model: 1,
                unit: {
                    name: '',
                    num:1,
                    price_model:1,
                    product_model:1,
                    template_model:1,
                    library_id: undefined,
                    product_id: undefined,
                    date_type: 0,
                    begin_time: moment().format('YYYY-MM-DD'),
                    budget_type: 0,
                    day_budget: 0,
                    bid_type: 10,
                    ocpx_action_type: 990,
                    region_type: 0,
                    region: [],
                    gender: 0,
                    age: 0,
                    ages_range: [0],
                    live_user_id: undefined,
                    series_id: undefined,
                    episode_id: undefined,
                    series_pay_mode: undefined,
                    series_pay_template_ids: [],
                    quick_search: true,
                    target_explore: true,
                    intelli_extend_option: false,
                    deep_conversion_type:undefined,
                    roi_ratio: 1,
                },
                creative: {
                    creative_type: 1,
                    kol_user_type: 2,
                    name: '',
                    action_bar_text: '',
                    description: [],
                    new_expose_tag: [],
                    creative_category: 70301,
                    creative_tag: [],
                    video_ids: [],
                    outer_loop_native: true,
                    micro_change_switch: true,
                    material_rule: 1,
                    material_num: '',
                    material_source_type: '1',
                    material_name: '',
                },
            },
            ocpxActions: [
                { id: 2, name: '行为数', disabled: true, is_pay: null },
                { id: 53, name: '表单转化', disabled: true, is_pay: null },
                { id: 180, name: '激活', disabled: true, is_pay: null },
                { id: 190, name: '付费', disabled: true, is_pay: true },
                { id: 191, name: '首日ROI (24h)', disabled: true, is_pay: true  },
                { id: 739, name: '7日付费次数', disabled: true, is_pay: null  },
                { id: 774, name: '7日ROI', disabled: true, is_pay: null  },
                { id: 773, name: '关键行为', disabled: false, is_pay: null  },
                { id: 990, name: '首日变现ROI（短剧IAA专用）', disabled: false, is_pay: false  },
            ],
            budgetTypes: [
                { id: 0, name: '不限', disabled: false },
                { id: 1, name: '统一预算', disabled: false },
                { id: 2, name: '分日预算', disabled: true },
            ],
            ages: [
                { id: 0, name: '不限' },
                { id: 18, name: '18-23' },
                { id: 24, name: '24-30' },
                { id: 31, name: '31-40' },
                { id: 41, name: '41-49' },
                { id: 50, name: '50+' },
            ],
            bidTypes: [
                { id: 0, name: '成本优先' },
                { id: 1, name: '最大转化' },
            ],
            buttons: [
                '在线观看',
                '已更完',
                '查看详情',
                '点击观看',
                '看全集',
                '继续观看',
                '观看全集',
            ],
            newExposeTags: [
                '精彩剧集一网打尽',
                '本周热门短剧',
                '海量热门短剧',
            ],
            sellingPoints: [],
            products: [],
            productDetails: [],
            awemes: [],
            corporations: [],
            loading: false,
            syncLoading: false,
            actionName: '操作',
            timeout: null,
            rules: {
                'ids': [{ required: true, message: '请选择广告主', trigger: 'change' }],
                'name': [{ required: true, message: '请输入计划名称', trigger: 'change' }],
                'day_budget': [{ required: true, message: '请输入预算金额', trigger: 'change' }],
                'num': [{ required: true, message: '请输入计划数量', trigger: 'change' }],
                'scene_id': [{ required: true, message: '请输入资源版位', trigger: 'change' }],
                'campaign_model': [{ required: true, message: '请选择计划模式', trigger: 'change' }],
                'unit.price_model': [{ required: true, message: '请选择账户出价模式', trigger: 'change' }],
                'unit.template_model': [{ required: true, message: '请选择账户付费模板模式', trigger: 'change' }],
                'unit.live_user_id': [{ required: true, message: '请选择目标快手号', trigger: 'change' }],
                'unit.series_id': [{ required: true, message: '请选择短剧', trigger: 'change' }],
                'unit.episode_id': [{ required: true, message: '请选择短剧集数', trigger: 'change' }],
                'unit.series_pay_mode': [{ required: true, message: '请选择短剧付费模式', trigger: 'change' }],
                'unit.series_pay_template_ids': [
                    { required: true, type: 'array', message: '请选择短剧付费模板', trigger: 'change' },
                    { validator: (rule, value, callback) => {
                        if (value && value.length > 5) {
                            callback('最多选择5个付费模板')
                        } else {
                            callback()
                        }
                    }, trigger: 'change' }
                ],
                'unit.begin_time': [{ required: true, message: '请选择投放开始日期', trigger: 'change' }],
                'unit.ages_range': [{ required: true, message: '请选择投放年龄段', trigger: 'change' }],
                'unit.name': [{ required: true, message: '请输入广告组名称', trigger: 'change' }],
                'unit.ocpx_action_type': [{ required: true, message: '请选择转化目标', trigger: 'change' }],
                'unit.day_budget': [{ required: true, message: '请输入预算金额', trigger: 'change' }],
                'unit.cpa_bid': [{ required: true, message: '请输入出价', trigger: 'change' }],
                'unit.roi_ratio': [{ required: true, message: '请输入ROI系数', trigger: 'change' }],
                'creative.creative_type': [{ required: true, message: '请选择制作方式', trigger: 'change' }],
                'creative.video_ids': [
                    {
                        required: true,
                        validator: (rule, value) => {
                            if (this.model.creative.material_source_type === '2') {
                                return Promise.resolve()
                            }
                            if (!value || value.length === 0) {
                                return Promise.reject('请选择素材');
                            }
                            return Promise.resolve();
                        },
                        trigger: 'change',
                    },
                ],
                'creative.material_name': [
                    {
                        validator: (rule, value) => {
                            if (this.model.creative.material_source_type === '2') {
                                if (!value || !value.trim()) {
                                    return Promise.reject('请输入素材名称')
                                }
                            }
                            return Promise.resolve()
                        },
                        trigger: 'change',
                    },
                ],
                'creative.description': [{ required: true, message: '请输入作品广告语', trigger: 'change' }],
                'creative.creative_category': [{ required: true, message: '请选择创意分类', trigger: 'change' }],
                'creative.creative_tag': [{ required: true, message: '请输入创意标签', trigger: 'change' }],
                'creative.action_bar_text': [{ required: true, message: '请选择行动号召', trigger: 'change' }],
                'creative.name': [{ required: true, message: '请输入创意名称', trigger: 'change' }],
            },
            result: {
                success: [],
                errors: [],
            },
            showResult: false,
            showResultPage: false,
            showSubmit: true,
            currentAdvId: null,
            titleGroups: [],
            series: [],
            episodes: [],
            pay_model_types: [],
            pay_templates: [],
            advertisers: [],
            deepConversionTypes: [
                { id: 92, name: '首日ROI' },
            ],
            campaigns:[],
            refreshingAwemes: false,
            seriesSearchLoading: false,
            seriesKeyword: '',
            materialCounts: [],
            materialCountsLoaded: false,
            materialCountsLoading: false,
        }
    },
    computed: {
        actType() {
            return this.model.id ? '修改' : '新建'
        },
        formStyle() {
            return this.showResultPage ? { display: 'flex', flexDirection: 'column', height: '100%' } : {}
        },
        stepStyle() {
            return this.showResultPage ? { flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 0 } : {}
        },
    },
    mounted() {
        if (this.params.params) {
            this.params.params.unit.num = this.params.params.unit.num ?? 1
            this.params.params.campaign_model = 1
            this.params.params.unit.price_model = this.params.params.unit.price_model ?? 1
            this.params.params.unit.product_model = this.params.params.unit.product_model ?? 1
            this.params.params.unit.template_model = this.params.params.unit.template_model ?? 1
            this.params.params.unit.deep_conversion_type = this.params.params.unit.deep_conversion_type ?? null
            this.params.params.creative.material_rule = this.params.params.creative.material_rule ?? 1
            this.params.params.creative.material_num = this.params.params.creative.material_num ?? ''
            this.params.params.creative.material_source_type = this.params.params.creative.material_source_type ?? '1'
            this.params.params.creative.material_name = this.params.params.creative.material_name ?? ''

            this.model = Object.assign({}, this.$helper.deepClone(this.params.params))
            this.$set(this.model, 'ids', this.params.advertiser_ids)
            this.model.num = 1
            this.init()
            if (moment(this.model.unit.begin_time).isBefore(moment(), 'day')) {
                this.model.unit.begin_time = moment().format('YYYY-MM-DD')
            }
            this.changeBidType()
        } else if (this.params.ids) {
            this.$set(this.model, 'ids', this.params.ids)
            this.init()
        }
        getTitleGroups().then(res => { this.titleGroups = res.data.list || [] })
        this.model.name = '新建广告计划_' + moment().format('YYYYMMDD_HH:mm')
        this.model.unit.name = '新建广告组_' + moment().format('YYYYMMDD_HH:mm')
        this.changeCreativeType()
       
        this.model.creative.action_bar_text = this.model.creative.action_bar_text || this.buttons[0]
        this.model.creative.material_source_type = this.model.creative.material_source_type || '1'
        this.model.creative.material_name = this.model.creative.material_name || ''
    },
    watch: {
    },
    created() {},
    methods: {
        changeCreativeType() {
            if (this.model.creative.creative_type === 2) {
                this.model.creative.name = '新建程序化创意_' + moment().format('YYYYMMDD_HH:mm')
                this.model.creative.micro_change_switch = false;
            } else {
                this.model.creative.name = '新建自定义创意_' + moment().format('YYYYMMDD_HH:mm')
                this.model.creative.micro_change_switch = true;
            }
        },
        changeMaterialSourceType(type) {
            if (type === '1' || type === '3') {
                // 广告素材/AI视频为互斥来源，切换时清空已选视频
                this.model.creative.video_ids = []
                this.model.creative.material_name = ''
                this.materialCounts = []
                this.materialCountsLoaded = false
            } else {
                this.model.creative.video_ids = []
                if (this.model.ids && this.model.ids.length > 0) {
                    this.queryMaterialCounts()
                }
            }
        },
        onMaterialNameChange() {
            if (!this.model.creative.material_name) {
                this.materialCounts = []
                this.materialCountsLoaded = false
                return
            }
            this.queryMaterialCounts()
        },
        queryMaterialCounts() {
            if (this.materialCountsLoading) return
            if (!this.model.ids || this.model.ids.length === 0) return
            if (!this.model.creative.material_name || !this.model.creative.material_name.trim()) return
            this.materialCountsLoaded = false
            this.materialCountsLoading = true
            getPushRecordCountByName({
                material_name: this.model.creative.material_name,
                advertiser_ids: this.model.ids,
                media: 1,
            }).then(res => {
                this.materialCounts = res.data.list || []
            }).finally(() => {
                this.materialCountsLoading = false
                this.materialCountsLoaded = true
            })
        },
        changeAdvs() {
            this.advertisers = []
            this.$nextTick(() => {
                if (this.currentAdvId !== this.model.ids[0]) {
                    this.$set(this.model, 'related_product', {
                        product_setting: 'SINGLE'
                    })
                }
            })
            this.$nextTick(this.init)
        },
        init() {
            const refreshProduct = this.currentAdvId !== this.model.ids[0]
            const advertiserFilter = { advertiser_id: this.model.ids[0] }
            this.currentAdvId = this.model.ids[0]
            if (this.model.ids.length === 0) {
                return false
            }

            getAdvertiserExts({ ids: this.model.ids }).then(res => {
                let advertisers = []
                this.advs = res.data.list || []
                
                if (this.advs && this.advertisers.length === 0) {
                    Object.values(this.advs).forEach( (item) => {
                        advertisers.push({id:item.id, advertiser_id:item.out_id, name:item.name,cpa_bid:null,roi_ratio:null, library_id: null, product_id:null, outer_id:null, series_pay_template_id:null,deep_conversion_type:null, campaign_id:null})
                    })
                    this.advertisers = advertisers
                }
            })
         
            if (refreshProduct) {
                this.loading = true
                if (this.model.unit.product_model == 2 && this.model.advertisers) {
                    getProducts({ advertiser_id: this.model.advertisers[0].id }).then(res => {
                        this.products[this.model.advertisers[0].id] = res.data.list || []
                    }).finally(() => {
                        this.loading = false
                    })
                    if (this.model.advertisers[0].product_id > 0) {
                        this.getProductDetails(this.model.advertisers[0].id, this.model.advertisers[0].library_id)
                    }
                } else {
                    getProducts(advertiserFilter).then(res => {
                        this.products[this.model.ids[0]] = res.data.list || []
                        if (this.model.unit.library_id > 0 && this.products[this.model.ids[0]].findIndex(item => item.id === this.model.unit.library_id) === -1) {
                            this.model.unit.library_id = null
                            this.model.unit.product_id = null
                        }
                    }).finally(() => {
                        this.loading = false
                    })
                    if (this.model.unit.product_id > 0) {
                        this.getProductDetails(this.model.ids[0], this.model.unit.library_id)
                    }
                }
            
                getAwemes(advertiserFilter).then(res => {
                    this.awemes = res.data.list || []
                    if (this.awemes.length > 0) {
                        this.awemes.forEach(element => {
                            if (element.id == 3620193097) {
                                this.model.unit.live_user_id = '3620193097'
                                this.getSeries(this.model.unit.live_user_id)
                            }
                        });
                        
                        if (!this.model.unit.live_user_id) {
                            this.model.unit.live_user_id = this.awemes[this.awemes.length - 1].id
                        }

                        if (!this.series || this.series.length === 0) {
                            this.getSeries(this.model.unit.live_user_id)
                        }
                    }
                })
            }
        },
        refreshAwemes () {
            if (this.refreshingAwemes) return
            this.refreshingAwemes = true

            getAwemes({ advertiser_id: this.model.ids[0] }).then(res => {
                this.awemes = res.data.list || []
                if (this.awemes.length > 0) {
                    this.awemes.forEach(element => {
                        if (element.id == 3620193097) {
                            this.model.unit.live_user_id = '3620193097'
                            this.getSeries(this.model.unit.live_user_id)
                        }
                    });
                    
                    if (!this.model.unit.live_user_id) {
                        this.model.unit.live_user_id = this.awemes[this.awemes.length - 1].id
                        this.getSeries(this.model.unit.live_user_id)
                    }
                }
            })
            .catch(err => {
                this.$message.error('刷新失败')
                console.error(err)
            })
            .finally(() => {
                this.refreshingAwemes = false
            })
        },
        refreshProducts (adv_id = null, library_id = null) {
            let advertiser_id = adv_id == null ? this.model.ids[0] : adv_id
            this.loading = true
            getProducts({ advertiser_id: advertiser_id }).then(res => {
                let this_adv_id = res.data.list || []
                this.products[advertiser_id] = this_adv_id
                this.$set(this.products, advertiser_id, this_adv_id)
            }).finally(() => {
                this.loading = false
            })
            if (library_id > 0) {
                this.getProductDetails(advertiser_id, library_id)
            }
        },
        getSeries(live_user_id, keyword = '') {
            this.loading = true
            getSeries({advertiser_id: this.model.ids[0], user_id: live_user_id, series_title: keyword}).then(res => {
                this.series = res.data.list || []
                if (this.series.length > 0) {
                     this.changeSeries(this.series[0].id)
                }
                this.loading = false
                this.seriesSearchLoading = false
            }).finally(() => {
                this.loading = false
                this.seriesSearchLoading = false
            })
        },
        changeSeries(series_id){
            getEpisodes({advertiser_id: this.model.ids[0], user_id: this.model.unit.live_user_id, series_id: series_id}).then(res => {
                this.episodes = res.data.list || []
                this.model.unit.episode_id = this.episodes[0].id
                this.loading = false
            }).finally(() => {
                this.loading = false
            })

            getPayModeType({advertiser_id: this.model.ids[0], user_id: this.model.unit.live_user_id, series_id: series_id}).then(res => {
                this.pay_model_types = res.data.list || []
                this.model.unit.series_pay_mode = this.pay_model_types[0].pay_mode

                getPayTemplates({advertiser_id: this.model.ids[0], user_id: this.model.unit.live_user_id, series_id: series_id, series_pay_mode:this.model.unit.series_pay_mode}).then(res => {
                    this.pay_templates = res.data.list || []
                    if (this.pay_templates.length>0) {
                        this.model.unit.ocpx_action_type = 191
                    }
                    this.loading = false
                }).finally(() => {
                    this.loading = false
                })
                this.loading = false
            }).finally(() => {
                this.loading = false
            })

            this.model.unit.series_id = series_id
            this.loading = false
        },
        changeKolUser(live_user_id) {
            this.series = []
            this.episodes = []
            this.pay_model_types = []
            this.pay_templates = []
            this.model.unit.series_id = null
            this.model.unit.episode_id = null
            this.model.unit.series_pay_mode = null
            this.model.unit.series_pay_template_ids = []
            this.seriesKeyword = ''

            this.getSeries(live_user_id)
        },
        disabledDate(current) {
            return current && current < moment().endOf('day')
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
            })

            if (this.model.campaign_model != 1) {
                for (const key in this.advertisers) {
                    const adv = this.advertisers[key]
                    if (!adv.campaign_id) {
                        return this.$message.error(`请填写广告主[${adv.name}]计划`)
                    }
                }
            }

            if (this.model.unit.product_model != 1) {
                for (const key in this.advertisers) {
                    const adv = this.advertisers[key]
                    if (!adv.library_id) {
                        return this.$message.error(`请选择广告主[${adv.name}]关联商品库`)
                    }
                    if (!adv.product_id) {
                        return this.$message.error(`请填写广告主[${adv.name}]关联产品`)
                    }
                }
            }

            if (this.model.unit.price_model != 1) {
                for (const key in this.advertisers) {
                    const adv = this.advertisers[key]
                    if ([190,773].includes(this.model.unit.ocpx_action_type) && !adv.cpa_bid) {
                        return this.$message.error(`请填写广告主[${adv.name}]出价`)
                    } else if ([191,990].includes(this.model.unit.ocpx_action_type) && !adv.roi_ratio) {
                        return this.$message.error(`请填写广告主[${adv.name}]ROI系数`)
                    }
                }
            }

            if (this.model.unit.template_model != 1) {
                for (const key in this.advertisers) {
                    const adv = this.advertisers[key]
                    if (!adv.series_pay_template_id) {
                        return this.$message.error(`请选择广告主[${adv.name}]付费模板`)
                    }
                }
            }

            if (this.model.creative.new_expose_tag.length>2) {
                return this.$message.error(`推荐理由，最多2个标签`)
            }

            for (const key in this.model.creative.description) {
                const item = this.model.creative.description[key]
                if (item.length>30) {
                    return this.$message.error(`作品广告语，第[${Number(key) + 1}]行超过30个字`)
                }
            }

            this.$message.destroy()
            this.storeOrUpdate()
        },
        storeOrUpdate() {
            this.loading = true
            let json = Object.assign({}, this.model)
            json.advs = this.advs
            json.advertisers = this.advertisers
            // console.log('准备提交：', this.media, json)

            storeOrUpdateAdTask(this.media, json).then(res => {
                this.loading = false
                this.openLowCostAdvertiserNotification(res && res.data)
                this.showResultPage = true
            }).catch(response => {
                this.loading = false
                this.openLowCostAdvertiserNotification(response && response.data && response.data.data)
            })
        },
        openLowCostAdvertiserNotification(data) {
            const advertisers = data && data.low_cost_advertisers
            if (!advertisers || !advertisers.length) {
                return
            }

            this.$notification.open({
                message: '快手低花费广告主提示',
                description: (
                    <div>
                        <div>统计区间：{data.started_at} 至 {data.finished_at}</div>
                        <div>限制规则：前3天存在广告计划并且花费总和小于{data.threshold}元的广告主</div>
                        {advertisers.map(item => (
                            <div key={item.id}>
                                广告主名称：{item.name}，广告主ID：{item.out_id}，花费：{item.charge}元
                            </div>
                        ))}
                    </div>
                ),
                duration: 0,
            })
        },
        doTask(taskId, advIndex) {
            this.loading = true
            const json = {
                id: taskId,
                advertiser_id: this.model.ids[advIndex]
            }
            storeOrUpdateAdTask(this.media, json).then(res => {
                this.result.success = this.result.success.concat(res.data.success || [])
                this.result.errors = this.result.errors.concat(res.data.errors || [])
            }).catch(() => {})
        },
        close() {
            this.$emit('success')
            this.$emit('update:showCreateForm', false)
        },
        changeBudgetType(e) {
            this.model.day_budget = e.target.value === 0 ? 0 : undefined
        },
        changeUnitBudgetType(e) {
            this.model.unit.day_budget = e.target.value === 0 ? 0 : undefined
        },
        changeAge(v) {
            this.changeHandle(v, 'ages_range', null)
        },
        changePlatform(v) {
            this.changeHandle(v, 'platform', '')
        },
        changeHandle(v, field, noneId) {
            if (v.length <= 1) {
                return true
            }
            if (v[v.length - 1] === noneId) {
                this.model.unit[field] = [noneId]
                return true
            }
            this.model.unit[field] = this.model.unit[field].filter(item => {
                return item !== noneId
            })
        },
        changeLibrary(library_id, option) {
            let adv_id = option.data.attrs.adv_id ?? null

            if (!adv_id) {
                adv_id = this.model.ids[0]
                delete this.model.unit.product_id
            }
          
            this.productDetails = []
            this.getProductDetails(adv_id, library_id)
        },
        changeProduct(product_id, option) {
            let outer_id = option.data.attrs.outer_id ?? null
            let adv_id = option.data.attrs.adv_id ?? null

            if (!adv_id) {
                this.model.unit.outer_id = outer_id
                this.model.unit.product_id = product_id
            } else {
                this.advertisers.forEach(element => {
                    if (element.id === adv_id) {
                        element.outer_id = outer_id
                        element.product_id = product_id
                    }
                });
            }
        },
        getProductDetails(adv_id, library_id) {
            const json = {
                advertiser_id: adv_id,
                library_id: library_id
            }
            this.loading = true
            getProductDetails(json).then(res => {
                let thisList = res.data.list || []
                this.productDetails[library_id] = thisList
                this.$set(this.productDetails, library_id, thisList)
            }).finally(() => {
                this.loading = false
            })
        },
        tabClass(adv) {
            if (!adv.external_url) {
                return 'tab-danger'
            }
            return ''
        },
        setTitleGroup(group) {
            this.$set(this.model.creative, 'description', group.titles)
            this.$nextTick(() => {
                this.$refs.title_group.init()
            })
        },
        syncData() {
            let advIds = []
            for (const key in this.advs) {
                advIds.push(this.advs[key].id)
            }
            const filters = { ids: advIds }
            const pullAnchorFn = () => { return pullAnchor(filters) }
            const pullUrlFn = () => {  return syncLandingPage(filters) }
            const refreshExt = () => {
                return getAdvertiserExts(filters).then(res => {
                    this.advs = res.data.list || []
                    this.$message.success('关联数据同步完成')
                }).finally(() => {
                    this.syncLoading = false
                })
            }
            this.syncLoading = true
            pullAnchorFn().finally(() => {
                pullUrlFn().finally(() => {
                    refreshExt()
                })
            })
        },
        changeBidType () {
            if (this.model.bid_type === 1) {
                this.model.budget_type = 1
                this.model.unit.bid_type = 12
                this.model.unit.budget_type = 0
                this.model.unit.day_budget = 0
            } else {
                this.model.budget_type = 0
                this.model.unit.bid_type = 10
            }
        },
        clickPane (activeKey) {
            if (this.model.unit.product_model === 2) {
                let adv_id = this.advertisers[activeKey].id
                if(!this.products[adv_id]){
                    this.refreshProducts(adv_id)
                } 
            }
        },
        changeProductModel () {
            if (this.model.unit.product_model === 2) {
                let adv_id = this.advertisers[0].id
                if(!this.products[adv_id]){
                    this.refreshProducts(adv_id)
                } 
            }
        },
        changeCampaignModel () {
            if (this.model.campaign_model === 2) {
                let adv_id = this.advertisers[0].id
                if(!this.campaigns[adv_id]){
                    this.refreshCampaigns(adv_id)
                } 
            }
        },
        refreshCampaigns (adv_id = null) {
            let advertiser_id = adv_id == null ? this.model.ids[0] : adv_id
            this.loading = true
            getKuaishouCampaigns({ advertiser_id: advertiser_id }).then(res => {
                let this_list = res.data.list || []
                this.campaigns[advertiser_id] = this_list
                this.$set(this.campaigns, advertiser_id, this_list)
            }).finally(() => {
                this.loading = false
            })
        },
        clickPaneCampaign (activeKey) {
            if (this.model.campaign_model === 2) {
                let adv_id = this.advertisers[activeKey].id
                if(!this.campaigns[adv_id]){
                    this.refreshCampaigns(adv_id)
                } 
            }
        },
        changePayMode (series_pay_mode) {
            getPayTemplates({advertiser_id: this.model.ids[0], user_id: this.model.unit.live_user_id, series_id: this.model.unit.series_id, series_pay_mode:series_pay_mode}).then(res => {
                this.pay_templates = res.data.list || []
                if (this.pay_templates.length>0) {
                    this.model.unit.ocpx_action_type = 191
                }
                this.loading = false
            }).finally(() => {
                this.loading = false
            })
        },
        searchSeries() {
            if (!this.model.unit.live_user_id) return
            this.seriesSearchLoading = true
            const keyword = this.seriesKeyword?.trim()
            this.getSeries(this.model.unit.live_user_id, keyword || undefined)
        },
    }
}
